import React from 'react';
import { Link } from 'react-router-dom';

const UserMenu = ({ user, handleLogout }) => {
  if (user) {
    return (
      <div className="relative group/account hidden lg:block">
        <div className="flex items-center space-x-2 text-slate-900 hover:text-yellow-700 transition-colors cursor-pointer py-2">
          <div className="w-8 h-8 rounded-full border border-slate-300 flex items-center justify-center bg-yellow-50 text-yellow-700 font-bold text-xs">
            {user.name.charAt(0).toUpperCase()}
          </div>
          <div className="flex flex-col text-left">
            <span className="text-xs font-semibold text-slate-900 leading-tight">Xin chào,</span>
            <span className="text-[10px] text-slate-600 leading-none mt-0.5 truncate max-w-[80px]">{user.name}</span>
          </div>
          <svg className="w-3 h-3 text-slate-500 transition-transform duration-300 group-hover/account:rotate-180" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </div>

        {/* Dropdown cho người dùng đã đăng nhập */}
        <div className="absolute right-0 mt-1 w-48 bg-white rounded-lg shadow-xl border border-slate-200 py-1.5 z-[10000] opacity-0 invisible group-hover/account:opacity-100 group-hover/account:visible transition-all duration-300 transform translate-y-1 group-hover/account:translate-y-0">
          <Link
            to="/profile"
            className="block px-4 py-2 text-xs text-slate-700 hover:bg-slate-50 hover:text-slate-900 transition-colors"
          >
            Hồ sơ cá nhân
          </Link>
          <Link
            to="/orders"
            className="block px-4 py-2 text-xs text-slate-700 hover:bg-slate-50 hover:text-slate-900 transition-colors"
          >
            Đơn hàng của tôi
          </Link>
          {user.role === 'admin' && (
            <Link
              to="/admin"
              className="block px-4 py-2 text-xs text-slate-700 hover:bg-slate-50 hover:text-slate-900 transition-colors font-medium border-t border-slate-100 mt-1 pt-2"
            >
              Trang quản trị
            </Link>
          )}
          <hr className="my-1.5 border-slate-100" />
          <button
            onClick={handleLogout}
            className="block w-full text-left px-4 py-2 text-xs text-red-600 hover:bg-red-50 transition-colors font-medium"
          >
            Đăng xuất
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="relative group/account hidden lg:block">
      <div className="flex items-center space-x-2 text-slate-900 hover:text-yellow-700 transition-colors cursor-pointer py-2">
        <div className="w-8 h-8 rounded-full border border-slate-300 flex items-center justify-center bg-slate-50 group-hover/account:bg-yellow-50 group-hover/account:border-yellow-200 transition-colors">
          <svg className="w-4 h-4 text-slate-600 group-hover/account:text-yellow-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
          </svg>
        </div>
        <div className="flex flex-col text-left">
          <span className="text-xs font-semibold text-slate-900 leading-tight">Tài khoản</span>
          <span className="text-[10px] text-slate-500 leading-none mt-0.5">Đăng nhập / Đăng ký</span>
        </div>
        <svg className="w-3 h-3 text-slate-500 transition-transform duration-300 group-hover/account:rotate-180" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </div>

      {/* Dropdown cho người dùng chưa đăng nhập */}
      <div className="absolute right-0 mt-1 w-44 bg-white rounded-lg shadow-xl border border-slate-200 py-2.5 z-[10000] opacity-0 invisible group-hover/account:opacity-100 group-hover/account:visible transition-all duration-300 transform translate-y-1 group-hover/account:translate-y-0">
        <Link
          to="/login"
          className="block mx-3 my-1 px-4 py-2 text-center text-xs font-bold uppercase tracking-wider text-slate-800 hover:text-white bg-slate-50 hover:bg-slate-900 rounded-md transition-all duration-200"
        >
          Đăng nhập
        </Link>
        <Link
          to="/register"
          className="block mx-3 my-1 px-4 py-2 text-center text-xs font-bold uppercase tracking-wider text-slate-950 hover:text-slate-950 bg-yellow-500 hover:bg-yellow-600 rounded-md transition-all duration-200 shadow-sm hover:shadow"
        >
          Đăng ký
        </Link>
      </div>
    </div>
  );
};

export default UserMenu;
